(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-thumbnails-web"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-thumbnails-web"] = factory(root["mggp-player"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_mggp_player__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/ThumbnailsPlaylistParser.js":
/*!*****************************************!*\
  !*** ./src/ThumbnailsPlaylistParser.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ThumbnailsPlaylistParser)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HEADER = '#EXTM3U';
var MEDIA = '#EXT-X-MEDIA:';
var START = 'START=';
var FINISH = 'FINISH=';
var IMAGE_COUNT = 'IMGCOUNT=';
var IMAGE_HEIGHT = 'IMGHEIGHT=';
var IMAGE_WIDTH = 'IMGWIDTH=';
var PROPERTY_DIVIDER = ',';
var ThumbnailsPlaylistParser = /*#__PURE__*/_createClass(function ThumbnailsPlaylistParser() {
  var _this = this;
  _classCallCheck(this, ThumbnailsPlaylistParser);
  _defineProperty(this, "parse", function (data) {
    var thumblines = [];
    if (data.indexOf(HEADER) !== -1 && data.indexOf(MEDIA) !== -1) {
      var lines = data.split('\n');
      var line;
      var url;

      // we suppose that first line should be header #EXTM3U
      for (var i = 1, l = lines.length; i < l; ++i) {
        line = lines[i];
        if (line.indexOf(MEDIA) !== -1) {
          url = ++i < l ? lines[i] : null;
          thumblines.push(_this.parseMedia(line, url));
        }
      }
    }
    return thumblines;
  });
  _defineProperty(this, "parseMedia", function (ln, url) {
    var line = ln.substr(MEDIA.length);
    var properties = line.split(PROPERTY_DIVIDER);
    var start;
    var finish;
    var count;
    var height;
    var width;
    var prop;
    for (var i = 0, l = properties.length; i < l; ++i) {
      prop = properties[i];
      if (prop.indexOf(START) !== -1) {
        start = parseInt(prop.substr(START.length));
      } else if (prop.indexOf(FINISH) !== -1) {
        finish = parseInt(prop.substr(FINISH.length));
      } else if (prop.indexOf(IMAGE_COUNT) !== -1) {
        count = parseInt(prop.substr(IMAGE_COUNT.length));
      } else if (prop.indexOf(IMAGE_WIDTH) !== -1) {
        width = parseInt(prop.substr(IMAGE_WIDTH.length));
      } else if (prop.indexOf(IMAGE_HEIGHT) !== -1) {
        height = parseInt(prop.substr(IMAGE_HEIGHT.length));
      }
    }
    var thumbsLine = {};
    thumbsLine.start = start;
    thumbsLine.finish = finish;
    thumbsLine.count = count;
    thumbsLine.height = height;
    thumbsLine.width = width;
    thumbsLine.url = url;
    return thumbsLine;
  });
});


/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!*******************************************!*\
  !*** ./src/mggp-plugin-thumbnails-web.js ***!
  \*******************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MggpPluginThumbnailsWeb)
/* harmony export */ });
/* harmony import */ var mggp_player__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mggp-player */ "mggp-player");
/* harmony import */ var mggp_player__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mggp_player__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ThumbnailsPlaylistParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ThumbnailsPlaylistParser */ "./src/ThumbnailsPlaylistParser.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



// What for this?
var MODE = {
  VOD: 'vod',
  DVR: 'dvr',
  DVR_LIVE: 'dvrLive',
  IDLE: 'idle'
};
var thumblistParser = new _ThumbnailsPlaylistParser__WEBPACK_IMPORTED_MODULE_1__["default"]();
var MggpPluginThumbnailsWeb = /*#__PURE__*/function (_Plugin) {
  function MggpPluginThumbnailsWeb() {
    var _this;
    _classCallCheck(this, MggpPluginThumbnailsWeb);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MggpPluginThumbnailsWeb, [].concat(args));
    /*
    // what reason in `mode`?
    constructor(...args) {
      super(...args);
       this.mode = MODE.IDLE;
    }
    */
    _defineProperty(_this, "dispose", function () {});
    _defineProperty(_this, "load", function (src, videoInfo) {
      if (!videoInfo) {
        /*
        // || isEquivalent(videoInfo, this.lastVideoInfo)) { // eslint-disable-line
        @todo: I'm does not want to fix repeating request due to problem is outside of the plugin,
        it should resolved by avoid repeating loading.
        */
        return;
      }
      _this.processVideoInfo(videoInfo);
    });
    _defineProperty(_this, "processVideoInfo", function (videoInfo) {
      var previewImages = videoInfo.preview_images;
      if (!previewImages) {
        return;
      }
      switch (videoInfo.content_type) {
        case 'm_ch_vod':
        case 'tv_dvr_vod':
        case 'vod':
          {
            _this.mode = MODE.VOD;
            var url = previewImages.thumbsline_xml;
            var images = previewImages.thumbsline_list_uhd || previewImages.thumbsline_list_full_hd || previewImages.thumbsline_list;
            if (!url || !images) {
              return;
            }
            _this.loadXML(url, images);
            break;
          }
        case 'tv_dvr':
          {
            _this.mode = MODE.DVR_LIVE;
            var playingProgram = _this.player.get('interactiveChannel:currentPlayingProgram');
            if (playingProgram && playingProgram.virtualStream) {
              _this.processVideoInfo(playingProgram.virtualStream);
            } else if (playingProgram && !playingProgram.virtualStream) {
              // TODO: disable waiting for virtual stream on dvr air
              // https://jira.x2sy.com/browse/MHP-1210
              // this.player.on('epg:programVirtualStreamUpdated', this.onVirtualStream);
            } else {
              _this.player.on('property:interactiveChannel:currentPlayingProgram', _this.onCurrentPlayingProgramChanged);
            }
            break;
          }
        case 'tv_dvr_catchup':
          {
            _this.mode = MODE.DVR;
            var _url = previewImages.thumbsline_url_uhd || previewImages.thumbsline_url_full_hd || previewImages.thumbsline_url;
            if (!_url) {
              return;
            }
            _this.loadM3U8(_url);
            break;
          }
        default:
      }
    });
    _defineProperty(_this, "reset", function () {});
    _defineProperty(_this, "expose", function (thumbnails) {
      _this.player.set('thumbnails', thumbnails);
    });
    _defineProperty(_this, "loadXML", function (url, framesCollection) {
      makeRequest(url, function (err, xhr) {
        if (err) {
          var message = xhr.status ? xhr.statusText : "".concat(url, " load failed");
          _this.log("MggpPluginThumbnails.load : ".concat(message));
          return;
        }
        var xml = xhr.responseXML;
        var info = xml.getElementsByTagName('thumbsline')[0];
        var thumbnails = new Array(framesCollection.length);
        try {
          framesCollection.forEach(function (line) {
            thumbnails[line.id - 1] = {
              frames: Number(xml.getElementById(line.id).getAttribute('imgcount')),
              url: line.url
            };
          });
        } catch (e) {
          _this.log("MggpPluginThumbnails: handle XML failure: ".concat(e.message));
          return;
        }
        var totalFrames = Number(info.getAttribute('imgcount'));
        var totalDuration = Number(info.getAttribute('vduration'));
        Object.defineProperty(thumbnails, 'frameDuration', {
          value: Math.round(totalDuration / totalFrames)
        });
        Object.defineProperty(thumbnails, 'startTime', {
          value: 0
        });
        _this.expose(thumbnails);
      });
    });
    _defineProperty(_this, "loadM3U8", function (url) {
      makeRequest(url, function (err, xhr) {
        if (err) {
          var message = xhr.status ? xhr.statusText : "".concat(url, " load failed");
          _this.log("MggpPluginThumbnails.load : ".concat(message));
          return;
        }
        var text = xhr.responseText;
        var data = thumblistParser.parse(text);
        var _data$reduce = data.reduce(calculateTotal, [0, 0]),
          _data$reduce2 = _slicedToArray(_data$reduce, 2),
          totalFrames = _data$reduce2[0],
          totalDuration = _data$reduce2[1];
        var thumbnails = data.map(function (fragment) {
          return {
            frames: fragment.count,
            url: fragment.url
          };
        });
        Object.defineProperty(thumbnails, 'frameDuration', {
          value: Math.round(totalDuration / totalFrames)
        });
        Object.defineProperty(thumbnails, 'startTime', {
          value: data[0] ? data[0].start : 0
        });
        _this.expose(thumbnails);
      });
    });
    _defineProperty(_this, "onCurrentPlayingProgramChanged", function (_ref) {
      var program = _ref.data;
      _this.player.off('property:interactiveChannel:currentPlayingProgram', _this.onCurrentPlayingProgramChanged);
      if (program) {
        _this.timeOffset = program.startTimestamp;
        if (!program.virtualStream) {
          _this.player.on('epg:programVirtualStreamUpdated', _this.onVirtualStream);
        }
      }
    });
    _defineProperty(_this, "onVirtualStream", function (_ref2) {
      var program = _ref2.data;
      _this.player.off('epg:programVirtualStreamUpdated', _this.onVirtualStream);
      _this.processVideoInfo(program.virtualStream);
    });
    return _this;
  }
  _inherits(MggpPluginThumbnailsWeb, _Plugin);
  return _createClass(MggpPluginThumbnailsWeb);
}(mggp_player__WEBPACK_IMPORTED_MODULE_0__.Plugin);

function calculateTotal(_ref3, fragment) {
  var _ref4 = _slicedToArray(_ref3, 2),
    frames = _ref4[0],
    duration = _ref4[1];
  return [frames + fragment.count, duration + (fragment.finish - fragment.start)];
}

/**
 * @param {string} url
 * @param {function(null|XMLHttpRequest, null|XMLHttpRequest)}callback
 */
function makeRequest(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.send();
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) {
      return;
    }
    if (xhr.status !== 200) {
      callback(xhr, null);
    }
    callback(null, xhr);
  };
}
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});